export default __webpack_public_path__ + "static/Fotolia_14924973_M-65307327a6033c69fa2634d7b270ae26.jpg";